import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTopcoderComponent } from './simple-icons-topcoder.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTopcoderComponent ],
    exports:      [ SimpleIconsTopcoderComponent ],
    bootstrap:    []
})
export class SimpleIconsTopcoderModule {}
